import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isConsumer } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isBrowserSupported } from 'owa-smime-adapter/lib/utils/smimeUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));

const SmimeOption: LazyOption = createLazyOption(
    {
        key: 'SmimeOption',
        titleStringKey: 'option_Smime_Title_Text',
        searchTermsStringKey: 'option_Smime_Title_Text',
        hideTitleInFullOptions: true,
        isHidden: () => isConsumer() || !isFeatureEnabled('cmp-smime') || !isBrowserSupported(),
    },
    lazyFullModule,
    m => m.default
);

export default SmimeOption;
